import { QuickFilterBar as FilterBar } from "components/form_components/QuickFilterBar";
import { getAppliedFilters, mergeCustomBuyersChip } from "components/form_components/utils";
import { EventDataTypes } from "lib/tracking";
import { BidSortBy } from "lib/types/graphQLEnums";
import { BidFilters, getBidColumnName } from "./utils";

export const filterKeyToLabel: Record<keyof BidFilters, string> = {
  assignee: "Assignee",
  createdBy: "Created by",
  stageIds: "Stage",
  value: "Value",
  createdDate: "Created date",
  lastUpdatedDate: "Last updated",
  submissionDate: "Submission date",
  awardDate: "Award date",
  buyers: "Buyers",
  customBuyers: "Buyers",
  buyerCategories: "Buyer type",
  buyerLists: "Buyer lists",
  buyerCountryRegions: "Buyer location",
  searchText: "",
  orderBy: "",
  order: "",
  entityId: "",
  supplierGuids: "Suppliers",
  supplierSme: "SME Supplier",
  teamIds: "Team",
};

export function QuickFilterBar({
  filters,
  onClearFilter,
  onFilterClick,
  clearAllFilters,
  isLoading,
  totalResults,
  valueSum,
}: {
  filters: BidFilters;
  onClearFilter: (value: keyof BidFilters) => void;
  onFilterClick: (value: keyof BidFilters) => void;
  clearAllFilters: () => void;
  isLoading: boolean;
  totalResults: number;
  valueSum: number;
}) {
  const appliedFiltersMapped = getAppliedFilters(
    {
      ...filters,
      lastUpdatedDate: {
        ...filters.lastUpdatedDate?.filter,
        hideNulls: filters.lastUpdatedDate?.hideNulls,
      },
      createdDate: {
        ...filters.createdDate?.filter,
        hideNulls: filters.createdDate?.hideNulls,
      },
      submissionDate: {
        ...filters.submissionDate?.filter,
        hideNulls: filters.submissionDate?.hideNulls,
      },
      awardDate: {
        ...filters.awardDate?.filter,
        hideNulls: filters.awardDate?.hideNulls,
      },
    },
    ["order", "orderBy"],
  );

  const appliedFiltersForBar = mergeCustomBuyersChip(appliedFiltersMapped);

  return (
    <FilterBar<BidFilters>
      appliedFilters={appliedFiltersForBar}
      isLoading={isLoading}
      totalResults={totalResults}
      filterKeyToLabel={filterKeyToLabel}
      onClear={onClearFilter}
      onFilterClick={onFilterClick}
      sortField={getBidColumnName(filters.orderBy ?? BidSortBy.UpdatedAt)}
      dataType={EventDataTypes.bids}
      hiddenFields={["searchText"]}
      clearAllFilters={clearAllFilters}
      valueSum={valueSum}
    />
  );
}
